// Date 2021-06-09 10:13:09

import emAcctLevel from "@/store/em/accident/EmAcctLevelStore.js";
import emAcctType from "@/store/em/accident/EmAcctTypeStore.js";
import emAcctHandleRecordAhr from "@/store/em/accident/EmAcctHandleRecordAhrStore.js";

const genericEntities = [
    'emAcctLevel',
    'emAcctType',
    'emAcctHandleRecordAhr'
]

const entities = {
    emAcctLevel,
    emAcctType,
    emAcctHandleRecordAhr
}

export {genericEntities}

export default entities